"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  number: "01",
  title: "Thermal Telemetry",
  description: "Deploy high-fidelity sensors to integrate with existing BMS for real-time entropy telemetry.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598652/img/blueprint_connect_data.png"
}, {
  number: "02",
  title: "Entropy Computation",
  description: "AI models analyze thermal gradients to identify reclaimable energy across the facility infrastructure.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598652/img/blueprint_ai_analysis.png"
}, {
  number: "03",
  title: "Autonomic Steering",
  description: "Automated control systems steer cooling loads to maximize exergy recovery and grid stability.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598652/img/blueprint_optimal_growth.png"
}];
export default function AgenticOnboarding() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="120407" id="operational-flow" className="dark bg-background py-24 overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {}
        <div ref={headerRef} className={`flex flex-col items-center text-center mb-16 transition-all duration-700 transform ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl font-sans font-bold tracking-widest uppercase text-foreground mb-6">
            Autonomic Thermal Intelligence. Integrated. Optimized.
          </h2>
          <div className="w-24 h-1 bg-primary mb-8 rounded-none shadow-[0_0_10px_rgba(57,255,20,0.5)]"></div>
          <p className="text-lg font-sans text-muted-foreground max-w-3xl tracking-wide">
            Our four-stage deployment protocol maps thermal waste, identifies exergy recovery vectors, and automates grid-scale efficiency.
          </p>
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {steps.map((step, i) => <div key={step.number} data-index={i} className={`relative bg-card rounded-none p-8 border border-border transition-all duration-500 hover:-translate-y-2 hover:border-primary hover:shadow-none flex flex-col h-full group ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              {}
              <div className="absolute top-6 right-6 text-7xl font-mono font-bold text-primary/10 select-none transition-colors duration-300 group-hover:text-primary/20">
                {step.number}
              </div>

              {}
              <div className="relative z-10 flex-grow flex flex-col">
                <h3 className="text-xl font-sans font-bold tracking-wider uppercase text-foreground mb-4 mt-12">
                  {step.title}
                </h3>
                <p className="text-muted-foreground font-sans mb-8 flex-grow tracking-tight">
                  {step.description}
                </p>
                
                {}
                <div className="mt-auto w-full h-48 relative rounded-none overflow-hidden bg-black border border-border transition-colors duration-300 group-hover:border-primary/40 flex items-center justify-center p-4">
                  <img src={step.image} alt={`${step.title} illustration`} className="w-full h-full object-contain opacity-40 group-hover:opacity-100 grayscale brightness-150 transition-all duration-500" />
                </div>
              </div>
            </div>)}
        </div>

      </div>
    </section>;
}